/* eslint-disable @typescript-eslint/no-explicit-any */
export function noop(): any {
  // empty function
}
